import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { UploadableFormAttachment } from './uploadable-form-attachment.model';
import * as UploadableFormAttachmentActions from './uploadable-form-attachment.actions';

export const uploadableFormAttachmentsFeatureKey = 'uploadableFormAttachments';

export interface State extends EntityState<UploadableFormAttachment> {
  // additional entities state properties
}

export const adapter: EntityAdapter<UploadableFormAttachment> = createEntityAdapter<UploadableFormAttachment>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(UploadableFormAttachmentActions.addUploadableFormAttachment,
    (state, action) => adapter.addOne(action.uploadableFormAttachment, state)
  ),
  on(UploadableFormAttachmentActions.upsertUploadableFormAttachment,
    (state, action) => adapter.upsertOne(action.uploadableFormAttachment, state)
  ),
  on(UploadableFormAttachmentActions.addUploadableFormAttachments,
    (state, action) => adapter.addMany(action.uploadableFormAttachments, state)
  ),
  on(UploadableFormAttachmentActions.upsertUploadableFormAttachments,
    (state, action) => adapter.upsertMany(action.uploadableFormAttachments, state)
  ),
  on(UploadableFormAttachmentActions.updateUploadableFormAttachment,
    (state, action) => adapter.updateOne(action.uploadableFormAttachment, state)
  ),
  on(UploadableFormAttachmentActions.updateUploadableFormAttachments,
    (state, action) => adapter.updateMany(action.uploadableFormAttachments, state)
  ),
  on(UploadableFormAttachmentActions.deleteUploadableFormAttachment,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(UploadableFormAttachmentActions.deleteUploadableFormAttachments,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(UploadableFormAttachmentActions.loadUploadableFormAttachments,
    (state, action) => adapter.setAll(action.uploadableFormAttachments, state)
  ),
  on(UploadableFormAttachmentActions.clearUploadableFormAttachments,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
